import React, { useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { getToken, getUserPref } from "../uttils/UserPref";

const ProtectAuction = () => {
  const navigate = useNavigate();
  const hasCheckedAuth = useRef(false);

  useEffect(() => {
    // Only check authentication once on initial load
    if (hasCheckedAuth.current) {
      return;
    }
    hasCheckedAuth.current = true;

    // Check if accessToken exists in localStorage
    const token = getToken();

    if (!token) {
      // No token, redirect to auction-auth
      navigate("/auction-auth");
      return;
    }

    // Get user data from localStorage
    const userDataString = getUserPref();

    if (!userDataString) {
      // No user data, redirect to auction-auth
      navigate("/auction-auth");
      return;
    }

    try {
      // Parse user data and check for tournamentId
      const userData = JSON.parse(userDataString);

      if (!userData?.tournamentId) {
        // User has token but no tournamentId, redirect to auction-auth
        navigate("/auction-auth");
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      navigate("/auction-auth");
    }
  }, [navigate]);

  // Return Outlet to render child routes
  return <Outlet />;
};

export default ProtectAuction;
